import React from 'react'
import { FormControl, Select, MenuItem } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import seasonFilterStyles from './seasonFilter.styles'

const ADD_SEASON = 'addSeason'

const useStyles = makeStyles(seasonFilterStyles)

const SeasonFilter = ({ seasons, selectedSeason, onSeasonChange, onAddSeason, className }) => {
  const classes = useStyles()

  const handleChange = (event) => {
    if (event.target.value === ADD_SEASON) {
      if (onAddSeason) onAddSeason()
      return
    }
    const seasonId = event.target.value
    const season = seasons?.find((s) => s.id === seasonId)
    onSeasonChange(season || null)
  }

  return (
    <FormControl className={`${classes.formControl} ${className}`}>
      <Select
        labelId='season-filter-label'
        id='season-filter'
        value={selectedSeason?.id || ''}
        onChange={handleChange}
        displayEmpty
        disabled={!seasons || seasons.length === 0}
      >
        {seasons && seasons.map((season) => (
          <MenuItem key={season.id} value={season.id}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {season.logoUrl && (
                <img
                  src={season.logoUrl}
                  alt={season.name}
                  style={{ width: 20, height: 20, objectFit: 'contain' }}
                />
              )}
              <span>{season.name}</span>
            </div>
          </MenuItem>
        ))}
        {onAddSeason && (
          <MenuItem value={ADD_SEASON}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <AddCircleIcon
                style={{ width: 20, height: 20, marginRight: 8, fill: '#E0726E' }}
              />
              <span style={{ color: '#555555', fontSize: '90%' }}>
                Add Season
              </span>
            </div>
          </MenuItem>
        )}
      </Select>
    </FormControl>
  )
}

export default SeasonFilter
